module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/624647b58ddb9eeafc70e87a608cefc5.png";